import sha256 from 'crypto-js/sha256';
export function getUserScopedStorageKeyPrefix(userId) {
  var userIdHash = sha256(userId).toString();
  return 'acornsweb_' + userIdHash.substring(0, 7) + '.';
}